const WaveWinter = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none">
    <svg
      viewBox="0 0 375.27 30.74"
      preserveAspectRatio="none"
      width="100%"
      height="100%"
    >
      <path
        fill="#CADDFC"
        d="M375.3 6.31822C344.492 0.653931 287.614 -6.55512 263.721 11.5118C230.147 36.876 164.588 12.5122 139.062 7.61293C72.0321 -5.26047 56.4075 24.6794 0 26.6508V365.422H375.3V6.31822Z"
      />
    </svg>
  </svg>
)

export default WaveWinter
